// src/pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center px-4 text-center">
      <h1 className="text-5xl font-bold text-red-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
      <p className="text-gray-500 mb-6">The page you are looking for does not exist or has been moved.</p>
      <Link
        to="/dashboard"
        className="px-6 py-3 bg-[var(--primary-font)] text-white rounded-lg hover:bg-[var(--secondary-font)] transition"
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
